(function () {
    if (window.__beautyCareJs) return;
    window.__beautyCareJs = true;

    var mq = window.matchMedia('(max-width: 850px)');

    function openPageLinksInNewTabs(root) {
        if (document.body.getAttribute('data-name') !== 'beauty-care') return;

        var scope = root && root.querySelectorAll ? root : document;

        scope.querySelectorAll('a[href]').forEach(function (link) {
            if (!link.closest('main')) return;

            var href = (link.getAttribute('href') || '').trim();

            if (!href || href.charAt(0) === '#' || /^(javascript:|mailto:|tel:)/i.test(href)) return;

            link.setAttribute('target', '_blank');
            link.setAttribute('rel', 'noopener noreferrer');
        });
    }

    function initUgc(root) {
        var sections = [];

        if (root.matches && root.matches('.beauty-ugc')) {
            sections.push(root);
        } else if (root.querySelectorAll) {
            root.querySelectorAll('.beauty-ugc').forEach(function (section) {
                sections.push(section);
            });
        }

        sections.forEach(function (section) {
            if (section.dataset.beautyUgcReady === 'true') return;
            section.dataset.beautyUgcReady = 'true';

            const track = section.querySelector('[data-beauty-ugc-track]');
            const prevButton = section.querySelector('[data-beauty-ugc-prev]');
            const nextButton = section.querySelector('[data-beauty-ugc-next]');
            const mediaAreas = section.querySelectorAll('.beauty-ugc__media');
            const tabButtons = section.querySelectorAll('[data-beauty-ugc-tab]');
            const togglePoster = (video, isVisible) => {
                const poster = video
                    ?.closest('.beauty-ugc__media')
                    ?.querySelector('.beauty-ugc__poster');

                if (!poster) return;

                poster.classList.toggle('is-hidden', !isVisible);
            };
            const getCardVideo = (card) => {
                if (!card) return null;

                return card.querySelector('video');
            };
            const getPlayButton = (video) => {
                return video?.closest('.beauty-ugc__card')?.querySelector('[data-beauty-ugc-play]');
            };
            const pauseVideo = (video) => {
                if (!video || video.paused) return;

                video.pause();
            };
            const resetPlayUi = (video) => {
                const button = getPlayButton(video);

                video.removeAttribute('controls');

                if (button) {
                    button.style.display = '';
                }

                togglePoster(video, true);
            };

            mediaAreas.forEach((media) => {
                media.addEventListener('click', (event) => {
                    const card = media.closest('.beauty-ugc__card');
                    const video = getCardVideo(card);
                    const button = media.querySelector('[data-beauty-ugc-play]');

                    if (!video) return;
                    if (event.target.closest('video') && video.controls) return;

                    section.querySelectorAll('video').forEach((otherVideo) => {
                        if (otherVideo !== video) {
                            pauseVideo(otherVideo);
                            resetPlayUi(otherVideo);
                        }
                    });

                    if (video.paused) {
                        video.setAttribute('controls', '');
                        video.play().then(() => {
                            if (button) {
                                button.style.display = 'none';
                            }

                            togglePoster(video, false);
                        }).catch(() => {
                            resetPlayUi(video);
                        });
                    } else {
                        video.pause();

                        if (button) {
                            button.style.display = '';
                        }

                        togglePoster(video, true);
                    }
                });
            });

            section.querySelectorAll('video').forEach((video) => {
                video.setAttribute('playsinline', '');
                video.setAttribute('webkit-playsinline', '');

                const button = getPlayButton(video);

                video.addEventListener('play', () => {
                    video.setAttribute('controls', '');

                    section.querySelectorAll('video').forEach((otherVideo) => {
                        if (otherVideo !== video && !otherVideo.paused) {
                            otherVideo.pause();
                        }
                    });

                    if (button) {
                        button.style.display = 'none';
                    }

                    togglePoster(video, false);
                });

                video.addEventListener('playing', () => {
                    if (button) {
                        button.style.display = 'none';
                    }

                    togglePoster(video, false);
                });

                video.addEventListener('pause', () => {
                    video.removeAttribute('controls');

                    if (button && !video.ended) {
                        button.style.display = '';
                    }

                    togglePoster(video, true);
                });

                video.addEventListener('ended', () => {
                    video.removeAttribute('controls');

                    if (button) {
                        button.style.display = '';
                    }

                    togglePoster(video, true);
                });
            });

            if (!track) return;

            const updateScrollableState = () => {
                const isScrollable = track.scrollWidth - track.clientWidth > 2;
                section.classList.toggle('beauty-ugc--scrollable', isScrollable);
                return isScrollable;
            };

            const getScrollAmount = () => {
                const card = track.querySelector('[data-beauty-ugc-card]:not([hidden])');

                if (!card) return 0;

                const style = window.getComputedStyle(track);
                const gap =
                    parseFloat(style.columnGap) ||
                    parseFloat(style.gap) ||
                    0;

                return card.getBoundingClientRect().width + gap;
            };

            const updateButtons = () => {
                updateScrollableState();

                if (!prevButton || !nextButton) return;

                const maxScroll = track.scrollWidth - track.clientWidth;

                prevButton.disabled = track.scrollLeft <= 2;
                nextButton.disabled = track.scrollLeft >= maxScroll - 2;
            };

            if (tabButtons.length) {
                tabButtons.forEach((button) => {
                    button.addEventListener('click', () => {
                        const tab = button.getAttribute('data-beauty-ugc-tab');

                        tabButtons.forEach((other) => {
                            const isActive = other === button;

                            other.classList.toggle('is-active', isActive);
                            other.setAttribute('aria-selected', isActive ? 'true' : 'false');
                        });

                        section.querySelectorAll('[data-beauty-ugc-card]').forEach((card) => {
                            const cardTab = card.getAttribute('data-beauty-ugc-card-tab');
                            const isVisible = !cardTab || cardTab === tab;

                            card.hidden = !isVisible;

                            if (!isVisible) {
                                card.querySelectorAll('video').forEach((video) => {
                                    pauseVideo(video);
                                    resetPlayUi(video);
                                });
                            }
                        });

                        track.scrollLeft = 0;
                        updateButtons();
                    });
                });
            }

            if (!prevButton || !nextButton) {
                updateScrollableState();
                window.addEventListener('resize', updateScrollableState);
                return;
            }

            prevButton.addEventListener('click', () => {
                track.scrollBy({
                    left: -getScrollAmount(),
                    behavior: 'smooth'
                });
            });

            nextButton.addEventListener('click', () => {
                track.scrollBy({
                    left: getScrollAmount(),
                    behavior: 'smooth'
                });
            });

            track.addEventListener('scroll', updateButtons, {
                passive: true
            });

            window.addEventListener('resize', updateButtons);

            updateButtons();
        });
    }

    function spacePx(el, n) {
        var probe = document.createElement('div');
        probe.style.cssText =
            'position:absolute;visibility:hidden;pointer-events:none;width:calc(' + n + ' * var(--px))';
        el.appendChild(probe);
        var value = probe.getBoundingClientRect().width;
        el.removeChild(probe);
        return value;
    }

    function howtoSections(root) {
        var sections = [];

        if (root.matches && root.matches('.beauty-howto')) {
            sections.push(root);
        } else if (root.querySelectorAll) {
            root.querySelectorAll('.beauty-howto').forEach(function (section) {
                sections.push(section);
            });
        }

        return sections;
    }

    function getHowtoVideo(media) {
        return media ? media.querySelector('video') : null;
    }

    function resetHowtoMedia(media) {
        if (!media) return;

        var video = getHowtoVideo(media);
        var cover = media.querySelector('.beauty-howto__cover');
        var button = media.querySelector('[data-beauty-howto-play]');

        if (video && !video.paused) {
            video.pause();
        }

        if (video) video.removeAttribute('controls');

        if (cover) cover.classList.remove('is-hidden');
        if (button) button.classList.remove('is-hidden');
    }

    function pauseHowtoSection(section) {
        section.querySelectorAll('.beauty-howto__media').forEach(resetHowtoMedia);
    }

    function bindHowtoMedia(section) {
        if (section.dataset.beautyHowtoMedia === 'true') return;
        section.dataset.beautyHowtoMedia = 'true';

        section.querySelectorAll('.beauty-howto__media').forEach(function (media) {
            media.addEventListener('click', function (event) {
                var video = getHowtoVideo(media);
                var cover = media.querySelector('.beauty-howto__cover');
                var button = media.querySelector('[data-beauty-howto-play]');

                if (!video) return;
                if (event.target.closest('video') && video.controls) return;

                section.querySelectorAll('.beauty-howto__media').forEach(function (other) {
                    if (other !== media) resetHowtoMedia(other);
                });

                if (video.paused) {
                    video.setAttribute('controls', '');
                    video.play().then(function () {
                        if (cover) cover.classList.add('is-hidden');
                        if (button) button.classList.add('is-hidden');
                    }).catch(function () {
                        video.muted = true;
                        return video.play();
                    }).then(function () {
                        if (video.paused) return;
                        if (cover) cover.classList.add('is-hidden');
                        if (button) button.classList.add('is-hidden');
                    }).catch(function () {
                        resetHowtoMedia(media);
                    });
                } else {
                    resetHowtoMedia(media);
                }
            });

            var video = getHowtoVideo(media);

            if (!video) return;

            video.setAttribute('playsinline', '');
            video.setAttribute('webkit-playsinline', '');

            video.addEventListener('play', function () {
                video.setAttribute('controls', '');

                section.querySelectorAll('.beauty-howto__media').forEach(function (other) {
                    if (other !== media) resetHowtoMedia(other);
                });

                var cover = media.querySelector('.beauty-howto__cover');
                var button = media.querySelector('[data-beauty-howto-play]');

                if (cover) cover.classList.add('is-hidden');
                if (button) button.classList.add('is-hidden');
            });

            video.addEventListener('pause', function () {
                if (!video.ended) resetHowtoMedia(media);
            });

            video.addEventListener('ended', function () {
                resetHowtoMedia(media);
            });
        });
    }

    function initHowtoSwiper(section) {
        var el = section.querySelector('[data-beauty-howto-swiper]');

        if (!el || typeof Swiper === 'undefined') return;

        var dots = section.querySelector('[data-beauty-howto-dots]');
        var nextEl = section.querySelector('.beauty-howto__nav .swiper-button-next');
        var prevEl = section.querySelector('.beauty-howto__nav .swiper-button-prev');
        var config = {
            watchOverflow: true,
            observer: true,
            observeParents: true,
            on: {
                slideChange: function () {
                    pauseHowtoSection(section);
                }
            }
        };

        if (el.swiper) {
            el.swiper.destroy(true, true);
            el.swiper = undefined;
        }

        if (mq.matches) {
            config.slidesPerView = 'auto';
            config.spaceBetween = spacePx(el, 9);
            config.slidesOffsetAfter = spacePx(el, 20);

            if (nextEl && prevEl) {
                config.navigation = {
                    nextEl: nextEl,
                    prevEl: prevEl
                };
            }
        } else {
            config.slidesPerView = 1;
            config.spaceBetween = 0;

            if (dots) {
                config.pagination = {
                    el: dots,
                    clickable: true
                };
            }
        }

        el.swiper = new Swiper(el, config);
    }

    function initHowto(root) {
        howtoSections(root).forEach(function (section) {
            bindHowtoMedia(section);
            initHowtoSwiper(section);
        });
    }

    function syncHowtoSwipers() {
        document.querySelectorAll('.beauty-howto').forEach(initHowtoSwiper);
    }

    function headerBottom() {
        var header = document.getElementById('shopify-section-header');
        if (!header) return 0;
        return Math.max(0, header.getBoundingClientRect().bottom);
    }

    function revealBenefitPopup(popup) {
        if (!popup || !popup.classList.contains('icon-hover')) return;
        var overlap = headerBottom() + 8 - popup.getBoundingClientRect().top;
        if (overlap <= 0) return;
        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollBy({
            top: -overlap,
            behavior: reduceMotion ? 'auto' : 'smooth'
        });
    }

    function closeBenefitTips(section) {
        section.querySelectorAll('.common-icon-tanchuang-box.icon-hover').forEach(function (box) {
            box.classList.remove('icon-hover');
        });
        section.querySelectorAll('.wenhao.wenhao-hover').forEach(function (el) {
            el.classList.remove('wenhao-hover');
        });
    }

    function initBenefitTips(root) {
        var sections = [];
        var scope = root || document;

        if (scope.matches && scope.matches('.beauty-care-section10')) {
            sections.push(scope);
        } else if (scope.querySelectorAll) {
            scope.querySelectorAll('.beauty-care-section10').forEach(function (section) {
                sections.push(section);
            });
        }

        sections.forEach(function (section) {
            if (section.getAttribute('data-beauty-benefit-ready') === 'true') return;
            section.setAttribute('data-beauty-benefit-ready', 'true');

            section.querySelectorAll('.wenhao').forEach(function (item) {
                var parent = item.closest('.common-icon-item-sy');
                var popup = parent && parent.querySelector('.common-icon-tanchuang-box');
                if (!popup) return;

                var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
                var show = function () {
                    closeBenefitTips(section);
                    popup.classList.add('icon-hover');
                    item.classList.add('wenhao-hover');
                    revealBenefitPopup(popup);
                };
                var hide = function () {
                    popup.classList.remove('icon-hover');
                    item.classList.remove('wenhao-hover');
                };

                if (finePointer) {
                    item.addEventListener('mouseenter', show);
                    item.addEventListener('mouseleave', function (event) {
                        if (popup.contains(event.relatedTarget)) return;
                        hide();
                    });
                    popup.addEventListener('mouseenter', show);
                    popup.addEventListener('mouseleave', hide);
                }

                item.addEventListener('click', function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                    var isOpen = popup.classList.contains('icon-hover');
                    closeBenefitTips(section);
                    if (!isOpen) show();
                });
            });
        });
    }

    function storiesSwipers(root) {
        var scope = root && root.querySelectorAll ? root : document;
        var nodes = [];

        if (root && root.matches && root.matches('.article-list-wrapper[data-layout="stories"]')) {
            nodes.push(root);
        }

        scope.querySelectorAll('.article-list-wrapper[data-layout="stories"]').forEach(function (section) {
            if (nodes.indexOf(section) === -1) nodes.push(section);
        });

        return nodes;
    }

    function bindStoriesScrollLock(el) {
        if (!el || el.dataset.beautyStoriesScrollLock === 'true') return;
        el.dataset.beautyStoriesScrollLock = 'true';

        el.addEventListener(
            'focusin',
            function (event) {
                if (!event.target.classList.contains('swiper-slide')) return;

                var x = window.scrollX;
                var y = window.scrollY;

                requestAnimationFrame(function () {
                    window.scrollTo(x, y);
                });
            },
            true
        );
    }

    function syncStoriesSwipers(root) {
        storiesSwipers(root || document).forEach(function (section) {
            var el = section.querySelector('.article-list-swiper');

            if (!el || !el.swiper) return;

            bindStoriesScrollLock(el);

            if (mq.matches) {
                el.swiper.params.slidesPerView = 'auto';
                el.swiper.params.spaceBetween = spacePx(el, 9);
                el.swiper.params.slidesOffsetAfter = spacePx(el, 20);
            } else {
                el.swiper.params.slidesPerView = 2;
                el.swiper.params.spaceBetween = spacePx(el, 20);
                el.swiper.params.slidesOffsetAfter = 0;
            }

            el.swiper.update();
        });
    }

    function boot(root) {
        openPageLinksInNewTabs(root || document);
        initUgc(root || document);
        initHowto(root || document);
        initBenefitTips(root || document);
        syncStoriesSwipers(root || document);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            boot(document);
        });
    } else {
        boot(document);
    }

    window.addEventListener('load', function () {
        document.querySelectorAll('.beauty-howto').forEach(function (section) {
            var el = section.querySelector('[data-beauty-howto-swiper]');

            if (el && !el.swiper) initHowtoSwiper(section);
        });
        syncStoriesSwipers(document);
    });

    document.addEventListener('shopify:section:load', function (event) {
        boot(event.target);
    });

    document.addEventListener('click', function (event) {
        if (
            event.target.closest('.beauty-care-section10 .wenhao') ||
            event.target.closest('.beauty-care-section10 .common-icon-tanchuang-box')
        ) {
            return;
        }
        document.querySelectorAll('.beauty-care-section10').forEach(closeBenefitTips);
    });

    if (mq.addEventListener) {
        mq.addEventListener('change', syncHowtoSwipers);
        mq.addEventListener('change', function () {
            syncStoriesSwipers(document);
        });
    } else {
        mq.addListener(syncHowtoSwipers);
        mq.addListener(function () {
            syncStoriesSwipers(document);
        });
    }

    var lastViewportWidth = window.innerWidth;

    window.addEventListener('resize', function () {
        var width = window.innerWidth;

        if (width === lastViewportWidth) return;
        lastViewportWidth = width;

        document.querySelectorAll('.beauty-howto').forEach(function (section) {
            var el = section.querySelector('[data-beauty-howto-swiper]');

            if (!el || !el.swiper) return;

            if (mq.matches) {
                el.swiper.params.spaceBetween = spacePx(el, 9);
                el.swiper.params.slidesOffsetAfter = spacePx(el, 20);
            }

            el.swiper.update();
        });
        syncStoriesSwipers(document);
    });
})();
